import { useState, useMemo } from 'react';

const useThrowError = () => {
  const [error, throwError] = useState<any>(null);
  useMemo(() => {
    if (error) {
      console.error(error);
      throw new Error(JSON.stringify(error));
    }
  }, [error]);
  return throwError;
};

export default useThrowError;
